// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"f266c239","89":"a5a10f94","109":"a5a10f94","129":"85fee901","137":"13dd8c0e","197":"a5a10f94","616":"301c1ab1","967":"a5a10f94"}[chunkId] + ".chunk.css";
};